import "./styles.css";

import { DeleteOutlined } from "@ant-design/icons";
import { Modal, Button, Typography } from "antd";

export default function ModalDelete({ open, setOpen, operation, itemName, id }: { open: boolean, setOpen: (val: boolean) => void, operation: (val: string) => void, itemName: string, id: string }) {

    return (
        <Modal
            onClose={() => setOpen(false)}
            open={open}
            title={'Excluir'}
            width={'600px'}
            onCancel={() => {
                setOpen(false)
            }}
            footer={
                <div className={'footer'}>
                    <Button onClick={() => setOpen(false)} className={'cancel-button'}>Cancelar</Button>
                    <Button onClick={() => {
                        setOpen(false)
                        operation(id);
                    }} className={'confirm-button'}>Confirmar</Button>
                </div>
            }
        >
            <div className={'content-container'}>

                <Typography className={'delete-text'}>Deseja Excluir o item "{itemName}"?</Typography>
            </div>

        </Modal>
    )
}